import { namespace } from "vuex-class"

export const isProduction: boolean = process.env.NODE_ENV === "production"
export const isTesting: boolean = process.env.NODE_ENV === "test"

export const GOOGLE_MAP_API_KEY: string =
    process.env.VUE_APP_GOOGLE_MAP_API_KEY || ""

export const U_ACS_TOKEN_IDENTIFIER = "U_ACS_TOKEN_IDENTIFIER"

export const MAPBOX_STYLES_ID_CATEGORY = "sbl_mapbox_styles_id"

export const RouterModuleNamespace = "Router"
export const UAcsLoginModuleNamespace = "UAcsLogin"
export const CountryModuleNamespace = "Country"
export const CompanyModuleNamespace = "Company"
export const MarketModuleNamespace = "Market"
export const VenueModuleNamespace = "Venue"
export const SmartBoxModuleNamespace = "SmartBox"
export const VersionModuleNamespace = "Version"

export const CountryModule = namespace(CountryModuleNamespace)
export const CompanyModule = namespace(CompanyModuleNamespace)
export const RouterModule = namespace(RouterModuleNamespace)
export const UAcsLoginModule = namespace(UAcsLoginModuleNamespace)
export const MarketModule = namespace(MarketModuleNamespace)
export const VenueModule = namespace(VenueModuleNamespace)
export const SmartBoxModule = namespace(SmartBoxModuleNamespace)
export const VersionModule = namespace(VersionModuleNamespace)

export const TimeRangeModuleNamespace = "TimeRange"

export const TimeRangeModule = namespace(TimeRangeModuleNamespace)
